import apiClient from '../client/api';

type CommPreference = {
  id: number;
  title: string;
  enabled: boolean;
};

type CommPreferences = {
  preferences: Array<CommPreference> | null;
};

type GetCommPreferencesResponse = CommPreferences;
type UpdateCommPreferencesPayload = Array<CommPreference>;

async function get(): Promise<GetCommPreferencesResponse> {
  const res = await apiClient.get('/communication-preferences');
  return res.data;
}

async function updateCommPreferences(payload: UpdateCommPreferencesPayload) {
  const response = await apiClient.put('/communication-preferences', payload);
  return response.data;
}

export default { get, updateCommPreferences };
